// confirmed,unconfirm,cancelled,modified

export const BookingStatus = [
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'unconfirm', label: 'Unconfirmed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'modified', label: 'Modified' },
]

export type BookingStatusType = typeof BookingStatus[number]['value']